/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.Reports {

    import IReportControl = Meevo.Model.IReportControl;

    const defaultValues: string[] = ['2', 'Both', '5.0%', '1'];

    class MeevoReportMa240Component implements angular.IComponentController {

        static $inject = [
            '$translate'
        ];

        public mainModel: Object;
        public parameterNames: string[];
        public securityAccess: any;
        public options: IReportControl;

        constructor(private $translate: angular.translate.ITranslateService) {
        }

        $onInit() {
            // set default control values
            for (let i = 0; i < defaultValues.length; i++) {
                if (i === 1) {
                    // dropdown parameter key will be present and the value set
                    // to 'hidden' if control should be hidden, otherwise set 
                    // default value
                    if (!this.mainModel.hasOwnProperty(this.parameterNames[1])) {
                        this.mainModel[this.parameterNames[1]] = this.options.values[0].value;
                    }
                } else {
                    this.mainModel[this.parameterNames[i]] = defaultValues[i];
                }
            }
        }
    }

    angular.module('meevo.plugins.reports')
        .component('meevoReportMa240Component', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/reports/components/ma240/meevo-report-ma240.component.html',
            controller: MeevoReportMa240Component,
            controllerAs: '$ctrl',
            bindings: {
                mainModel: '<',
                parameterNames: '<',
                securityAccess: '<',
                validationJson: '<',
                options: '<',
                disabled: '=?ngDisabled'
            }
        });
}
